import React, { Fragment, useEffect } from 'react';
import { Col, Container } from 'reactstrap';
import { BACK_TO_HOME_PAGE, ErrorPageContent, Pagenotfound } from '../../Constant'
import { Error5 } from '../../Data/Page/Svg'
import { H3 } from '../../AbstractElements';
import { useLocation, useNavigate } from 'react-router';

const Error = () => {
  

  const handleGoBack = () => {
   window.history.back()
  };
  return (
    <Fragment>
      <div className='page-wrapper compact-wrapper' id='pageWrapper'>
        <div className='error-wrapper mt-4'>
          <Container>
            <div className='svg-wrapper error5'>
              <Error5 />
            </div>
            <Col md="8" className="offset-md-2">
              <H3>Subscription Required.</H3>
              <p>Please subscribe to access this page</p>
              <button className='btn btn-primary' onClick={handleGoBack}>Go Back</button>

            </Col>
          </Container>
        </div>
      </div>
    </Fragment>
  )
}

export default Error